import React from "react";
import { useSidebarMenuItems } from "./hooks/useSidebarMenuItems";
import { SidebarView } from "./components/SidebarView";

export function PlatformSidebar() {
  const { analyzeItems, configureItems, utilityItems, footerItems, isLoading } =
    useSidebarMenuItems();

  return (
    <SidebarView
      analyzeItems={analyzeItems}
      configureItems={configureItems}
      utilityItems={utilityItems}
      footerItems={footerItems}
      isLoading={isLoading}
    />
  );
}
